module.exports = __webpack_public_path__ + "img/icon5.01644ff9.png";